import React, { useEffect, useState, useRef } from "react";
import * as Mui from "@mui/material";
import { useSelector } from "react-redux";
import { useFetch } from "services/hooks/useFetch";
import { tableRowSx, themes, headerMessage } from "services/constants";
import { leaveTypeHeader } from "pages/HR/Headers";
import { tableData } from "services/constants/Styles";
import { Edit, RemoveRedEye } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { CustomButton } from "components/CustomComponents/CustomButton";
import { TableEmptyState } from "components/CustomComponents/EmptyState";
import { AddLeaveType } from "./AddLeaveType";
import { Loader } from "components/Loader";
import { ViewLeaveType } from "./ViewLeaveType";
import { EditLeaveType } from "./EditLeaveType";
import { setGlobalSearchValue } from "services/Redux/userToken";
import { checkEditorPermission } from "services/utils/HelperFunction";
import { showToast } from "services/utils/Status";
import { tooltipStyleProps } from "services/constants/Styles";

const leaveTypeKey = ["name", "no_of_configuration"];
export const LeaveType = () => {
  const { domain, globalSearchValue, userScreenAccess } = useSelector(
    (state) => state.tokenReducer,
  );
  const dispatch = useDispatch();
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const {
    result: masterLeaveType,
    loading: loader,
    setLoad: setApiCall,
  } = useFetch(`${domain}new-leave-type/`);
  const [viewDetails, setViewDetails] = useState(null);
  const [showViewDetails, setShowViewDetails] = useState(false);
  const [addLeaveType, setAddLeaveType] = useState(false);
  const [page, setPage] = useState(0);
  const [editLeaveDetails, setEditLeaveDetails] = useState({});
  const [editLeave, setEditLeave] = useState(false);
  const [leaveTypes, setLeaveTypes] = useState(masterLeaveType);
  const [tableHeight, setTableHeight] = useState(window.innerHeight * 0.75);
  const containerRef = useRef(null);

  useEffect(() => {
    const updateHeight = () => {
      setTableHeight(window.innerHeight * 0.75);
    };

    window.addEventListener("resize", updateHeight);

    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = 0;
    }
  }, [page]);

  useEffect(() => {
    const filteredResults = masterLeaveType.filter((item) =>
      leaveTypeKey.some((key) =>
        item[key]
          ?.toString()
          .toLowerCase()
          .includes(globalSearchValue.toString().toLowerCase()),
      ),
    );
    setLeaveTypes(filteredResults);
    setPage(globalSearchValue ? 0 : page);
  }, [globalSearchValue, masterLeaveType, page]);
  return loader ? (
    <Loader info="Loading..." />
  ) : showViewDetails ? (
    <ViewLeaveType
      viewDetails={viewDetails}
      setShowViewDetails={setShowViewDetails}
      setApiCallForLeaveType={setApiCall}
    />
  ) : (
    <React.Fragment>
      {headerMessage(
        "Leave Type",
        "Configure the leave types available for assignment",
      )}
      <Mui.Grid
        container
        sx={{
          padding: 1,
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          alignItems: "flex-end",
          paddingRight: 2.5,
        }}
      >
        <CustomButton
          actionFuntion={() => {
            if (
              checkEditorPermission(
                userScreenAccess?.module_details,
                "LMS",
                "Leave Type",
              )
            ) {
              setAddLeaveType(true);
            } else {
              showToast(
                "error",
                "Access denied: You are not authorized to add leave type",
              );
            }
          }}
          actionName="Add Leave Type"
          typeName="submit"
        />
      </Mui.Grid>
      <Mui.Grid container>
        <Mui.TableContainer
          ref={containerRef}
          sx={{
            mt: 2,
            width: "100%",
            paddingLeft: 1,
            maxHeight: tableHeight,
            ml: 2,
            mr: 2,
            // "&::-webkit-scrollbar": { display: "none" }, // Hide scrollbar (Chrome, Safari)
            // "-ms-overflow-style": "none", // Hide scrollbar (IE, Edge)
            // "scrollbar-width": "none", // Hide scrollbar (Firefox)
          }}
        >
          <Mui.Table className="border">
            <Mui.TableHead
              sx={{
                backgroundColor: themes.primary,
                position: "sticky",
                top: -1,
                zIndex: 10,
              }}
            >
              <Mui.TableRow maxWidth="xl" align="left" sx={tableRowSx}>
                {leaveTypeHeader?.map((head) => (
                  <Mui.TableCell sx={tableData}>{head.name}</Mui.TableCell>
                ))}
              </Mui.TableRow>
            </Mui.TableHead>
            <Mui.TableBody>
              {leaveTypes?.length === 0 && !loader ? (
                <TableEmptyState dataLength={masterLeaveType} />
              ) : (
                leaveTypes
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  ?.map((item, index) => (
                    <Mui.TableRow maxWidth="xl" align="left" sx={tableRowSx}>
                      {leaveTypeHeader?.map((head) =>
                        head.name !== "Actions" ? (
                          <Mui.TableCell
                            onDoubleClick={() => {
                              setViewDetails(item);
                              setShowViewDetails(true);
                              dispatch(setGlobalSearchValue(""));
                            }}
                          >
                            <Mui.Tooltip
                              arrow
                              slotProps={tooltipStyleProps}
                              title={item[head.key]}
                            >
                              {head.name === "Color Code" ? (
                                <Mui.TextField
                                  type="color"
                                  value={item[head.key]}
                                  variant="standard"
                                  disabled={true}
                                  InputProps={{ disableUnderline: true }}
                                  sx={{
                                    border: "none",
                                    width: 150,
                                    "& input": {
                                      padding: 0,
                                      height: 20,
                                    },
                                  }}
                                />
                              ) : (
                                <Mui.Typography
                                  sx={{
                                    width: "200px", // Set a fixed width
                                    overflow: "hidden",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {item[head.key]}
                                </Mui.Typography>
                              )}
                            </Mui.Tooltip>
                          </Mui.TableCell>
                        ) : (
                          <Mui.TableCell sx={tableData}>
                            <Mui.IconButton
                              onClick={() => {
                                if (
                                  checkEditorPermission(
                                    userScreenAccess?.module_details,
                                    "LMS",
                                    "Leave Type",
                                  )
                                ) {
                                  setEditLeave(true);
                                  setEditLeaveDetails(item);
                                } else {
                                  showToast(
                                    "error",
                                    "Access denied: You are not authorized to edit leave type",
                                  );
                                }
                              }}
                            >
                              <Edit />
                            </Mui.IconButton>
                            <Mui.IconButton
                              onClick={() => {
                                if (
                                  checkEditorPermission(
                                    userScreenAccess?.module_details,
                                    "LMS",
                                    "Leave Type",
                                  )
                                ) {
                                  setViewDetails(item);
                                  setShowViewDetails(true);
                                  dispatch(setGlobalSearchValue(""));
                                } else {
                                  showToast(
                                    "error",
                                    "Access denied: You are not authorized to view leave type",
                                  );
                                }
                              }}
                            >
                              <RemoveRedEye
                                sx={{
                                  cursor: "pointer",
                                }}
                              />
                            </Mui.IconButton>
                          </Mui.TableCell>
                        ),
                      )}
                    </Mui.TableRow>
                  ))
              )}
            </Mui.TableBody>
          </Mui.Table>
        </Mui.TableContainer>
      </Mui.Grid>
      {leaveTypes?.length > 25 ? (
        <Mui.TablePagination
          className="custom-pagination"
          component="div"
          rowsPerPageOptions={[25, 50, 75, 100]}
          count={leaveTypes?.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      ) : null}
      <AddLeaveType
        addLeaveType={addLeaveType}
        setAddLeaveType={setAddLeaveType}
        setApiCall={setApiCall}
      />
      <EditLeaveType
        editLeave={editLeave}
        setEditLeave={setEditLeave}
        setApiCall={setApiCall}
        editLeaveDetails={editLeaveDetails}
      />
    </React.Fragment>
  );
};
